import React, { useState, useEffect, useContext, useCallback } from "react";
import CardForm from "./CardForm";
import EFTForm from "./EFTForm";
import { Card } from "react-bootstrap";
import { Form, useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import { getAPIData } from "../services/guestService";
import { postData } from "../services/guestService";
import { JSEncryptContext } from "../contexts/JSEncryptContext";
import { v4 as uuidv4 } from "uuid";
import { Spinner } from "react-bootstrap";
import { PaymentNachaContext } from "../contexts/PaymentNachaContext";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { LogContext } from "../contexts/LogContext";
import { encryptData } from "../utils/cryptoEncrypt";
import { dompurifyInput } from "../utils/sanitizeInput";

const PaymentMethodTab = ({
  paymentConfig,
  urlCarrier,
  // triggerToast,
  paymentType,
  payOtherAmount,
  payOtherAmtErr,
  updatePayOtherAmtErr,
  showTotalAmt,
  totalAmountDue,
  cim,
  cms,
  setNotifyErr,
  setNotifySuccess,
  updateTotalAmtDueErr,
  langSelected,
  showOtherAmt,
  handlePayTotalAmtdue,
  caseNum,
  hixIndicator,
  contactName,
}) => {
  const [isEnableDebit, setIsEnableDebit] = useState(false);
  const [isEnableCredit, setIsEnableCredit] = useState(false);
  const [isEnableEft, setIsEnableEft] = useState(false);
  const [isCardTypeAllowed, SetIsCardTypeAllowed] = useState(false); //PMO0001745 phase 2

  /*const [showCreditTab, setShowCreditTab] = useState(false);
  const [showDebitTab, setShowDebitTab] = useState(false);
  const [showCreditDebitTab, setShowCreditDebitTab] = useState(false);
  const [showEftTab, setShowEftTab] = useState(false);*/
  const [showCardTab, setShowCardTab] = useState(false);
  const [showEftTab, setShowEftTab] = useState(false);
  const [enableDebitCheck, setIsEnableDebitCheck] = useState(false);
  const [allowedCreditCardTypes, setAllowedCreditCardTypes] = useState([]);
  const [allowedDebitCardTypes, setAllowedDebitCardTypes] = useState([]);
  const [allowedEftTypes, setAllowedEftTypes] = useState([]);

  const [cardButtonName, setCardButtonName] = useState("");
  const [cardErrors, setCardErrors] = useState({});
  const [accountErrors, setAccountErrors] = useState({});
  const [errorText, setErrorText] = useState("");
  const [loading, setLoading] = useState(false);
  const [showSubmitBtn, setShowSubmitBtn] = useState(false);

  const [isDisabledSubmitBtn, setIsDisabledSubmitBtn] = useState(true);
  const [showConfirmBox, setShowConfirmBox] = useState(false);
  // Check if current carrier is excluded for carousel
  const carouselExcludedCarriers = (
      process.env.REACT_APP_CAROUSEL_EXCLUDED_CARRIERS || ""
  )
      .split(",")
      .map((c) => c.trim().toLowerCase());

  const isCarouselExcluded = carouselExcludedCarriers.includes(
      urlCarrier?.toLowerCase()
  );
  //const [confirmBoxMessage, setConfirmBoxMessage] = useState("");
  //const [nachaAuthMessage, setNachaAuthMessage] = useState("");

  // State for dynamic values to replace placeholders

  const [card, setCard] = useState({
    cardNumber: "",
    reEnterCardNumber: "",
    cardTypeSelect: "",
    debitCheck: "",
    cardAccountName: "",
    accountType: "",
    cardBillingAddress1: "",
    cardBillingAddress2: "",
    email: "",
    city: "",
    state: "",
    zip: "",
    phoneNumber: "",
    expiry: "",
    cvv: "",
    termsConditions: false,
    eSign: false,
  });

  const [form, setForm] = useState({
    routingNumber: "",
    reRoutingNumber: "",
    accountNumber: "",
    reAccountNumber: "",
    accountType: "",
    /* accountUse: "Personal",*/
    bankAccountHolderName: "",
    billingAddress1: "",
    billingAddress2: "",
    email: "",
    city: "",
    state: "",
    zip: "",
    phoneNumber: "",
    termsConditions: false,
    eSign: false,
  });
  const {
    getNachaContent,
    nachaContent,
    setNachaContent,
    nachaMainHeading,
    nachaTermsConditions,
    nachaESign,
    nachaCarrierName,
    nachaBillingFreq,
    nachaContentSubHeading,
  } = useContext(PaymentNachaContext);

  const { Log } = useContext(LogContext);

  const navigate = useNavigate();

  const showCard = (event) => {
    event.preventDefault();
    setShowCardTab(true);
    setShowEftTab(false);
    setShowSubmitBtn(false);
  };

  const showEFT = (event) => {
    event.preventDefault();
    setShowEftTab(true);
    setShowCardTab(false);
    setShowSubmitBtn(false);
  };
  const { encryptText } = useContext(JSEncryptContext);

  useEffect(() => {
    if (errorText) {
      setNotifyErr(errorText);
      setErrorText("");
    }
  }, [setNotifyErr, errorText]);

  useEffect(() => {
    if (showCardTab) {
      if (card.termsConditions && card.eSign) {
        setIsDisabledSubmitBtn(false);
      } else {
        setIsDisabledSubmitBtn(true);
      }
    }
    if (showEftTab) {
      if (form.termsConditions && form.eSign) {
        setIsDisabledSubmitBtn(false);
      } else {
        setIsDisabledSubmitBtn(true);
      }
    }
  }, [showCardTab, showEftTab, card, form]);

  useEffect(() => {
    /* Conditional enabling of Payment Method Button and Contents*/
    if (paymentConfig.debit_card?.debit_card_allowed === "YES") {
      setIsEnableDebit(true);
      if (paymentConfig.debit_card.debit_card_types) {
        setAllowedDebitCardTypes(paymentConfig.debit_card.debit_card_types);
      }
    }
    if (paymentConfig.credit_card?.credit_card_allowed === "YES") {
      setIsEnableCredit(true);
      if (paymentConfig.credit_card.credit_card_types) {
        setAllowedCreditCardTypes(paymentConfig.credit_card.credit_card_types);
      }
    }
    //PMO0001745 Phase 2 begins
    if (paymentConfig.credit_card?.is_card_type_allowed === "YES" || paymentConfig.debit_card?.is_card_type_allowed === "YES") {
      SetIsCardTypeAllowed(true);
    }//PMO0001745 Phase 2 ends

    if (paymentConfig.eft?.eft_allowed === "YES") {
      setIsEnableEft(true);
      if (paymentConfig.eft.eft_types) {
        setAllowedEftTypes(paymentConfig.eft.eft_types);
      }
    }
    /* Set card button name */
    if (isEnableCredit && isEnableDebit) {
      setCardButtonName(cms.label_pmt_card);
    } else if (isEnableCredit && !isEnableDebit) {
      setCardButtonName(cms.label_pmt_card);
    } else if (!isEnableCredit && isEnableDebit) {
      setCardButtonName(cms.label_pmt_debit_card);
      setIsEnableDebitCheck(true);
    }
    /* Make a button as active by default */
    if (showCardTab === false && showEftTab === false) {
      if (isEnableCredit || isEnableDebit) {
        setShowCardTab(true);
      } else {
        if (isEnableEft) {
          setShowEftTab(true);
        }
      }
    }
  }, [
    paymentConfig,
    isEnableCredit,
    isEnableDebit,
    isEnableEft,
    showCardTab,
    showEftTab,
    cms,
  ]);

  const sanitizeFormData = (formData) => {
    const sanitizedData = {};
    for (const key in formData) {
      if (typeof card[key] === "string") {
        sanitizedData[key] = dompurifyInput(formData[key]);
      } else {
        sanitizedData[key] = formData[key]; // keep non-string values as-is
      }
    }
    return sanitizedData;
  };

  function getJsonString(postdata) {
    let jsonString = "{";
    for (let key in postdata) {
      if (postdata.hasOwnProperty(key)) {
        jsonString = jsonString + `"${key}":"${postdata[key]}",`;
      }
    }
    jsonString = jsonString.slice(0, -1) + "}"; // Remove the last comma and close the brace
    return jsonString;
  }
  function getEncryptedPostdataString(postdata) {
    // Creating specific postdata sections using object literals
    const postdataName = {
      first_name: postdata.first_name,
      last_name: postdata.last_name,
    };

    const postdataAddress = {
      street1: postdata.street1,
      street2: postdata.street2,
      city: postdata.city,
      state: postdata.state,
      zip: postdata.zip,
      country: postdata.country,
    };

    const postdataContact = {
      email: postdata.email,
      phone: postdata.phone,
      carrier_code: postdata.carrier_code,
      debit_card_flag: postdata.debit_card_flag,
      binder_flag: postdata.binder_flag,
      gateway_id: postdata.gateway_id,
    };

    const postdataPayment = showEftTab
      ? {
          check_type: postdata.check_type,
          check_routing: postdata.check_routing,
          check_level: postdata.check_level,
          method: postdata.method,
          /* cc_type: postdata.cc_type,
      cc_number: postdata.cc_number,
      cc_exp_month: postdata.cc_exp_month,
      cc_exp_year: postdata.cc_exp_year,
      card_cvNumber: postdata.card_cvNumber,*/
          check_number: postdata.check_number,
          currency: postdata.currency,
        }
      : {
          method: postdata.method,
          cc_type: postdata.cc_type,
          cc_number: postdata.cc_number,
          cc_exp_month: postdata.cc_exp_month,
          cc_exp_year: postdata.cc_exp_year,
          card_cvNumber: postdata.card_cvNumber,
          currency: postdata.currency,
        };

    // Assuming you need to encrypt and combine the data
    /*const encryptedPostdata = {
      postdataName,
      postdataAddress,
      postdataContact,
      postdataPayment,
    };*/

    // Convert object to JSON string (to be encrypted, for example)
    //const postdataString = JSON.stringify(encryptedPostdata);
    const postdataNameStr = getJsonString(postdataName);
    const postdataNameStrEn = encryptText(postdataNameStr);
    const postdataNameParam = `en_nm=${encodeURIComponent(postdataNameStrEn)}`;

    const postdataAddressStr = getJsonString(postdataAddress);
    const postdataAddressStrEn = encryptText(postdataAddressStr);
    const postdataAddressParam = `en_ad=${encodeURIComponent(
      postdataAddressStrEn
    )}`;

    const postdataContactStr = getJsonString(postdataContact);
    const postdataContactStrEn = encryptText(postdataContactStr);
    const postdataContactParam = `en_cn=${encodeURIComponent(
      postdataContactStrEn
    )}`;

    const postdataPaymentStr = getJsonString(postdataPayment);
    const postdataPaymentStrEn = encryptText(postdataPaymentStr);
    const postdataPaymentParam = `en_pi=${encodeURIComponent(
      postdataPaymentStrEn
    )}`;

    // Combine all the parameters using a template literal or join
    const postdataString = [
      postdataNameParam,
      postdataAddressParam,
      postdataContactParam,
      postdataPaymentParam,
    ].join("&"); // Using .join to concatenate the strings with '&'    return postdataString; // You would return this to be encrypted or used further
    return postdataString;
  }

  //Validate credit card
  const validateCreditCard = (cardNumber) => {
    // Regular expression for validating common credit card formats (Visa, MasterCard, etc.)
    const cardPattern =
      /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9]{2})[0-9]{12}|3[47][0-9]{13}|(6011|622|64[4-9]|65)[0-9]{13,16})$/;
    return cardPattern.test(cardNumber) && luhnCheck(cardNumber);
  };

  const luhnCheck = (cardNumber) => {
    let sum = 0;
    let shouldDouble = false;
    for (let i = cardNumber.length - 1; i >= 0; i--) {
      let digit = parseInt(cardNumber.charAt(i), 10);
      if (shouldDouble) {
        digit *= 2;
        if (digit > 9) digit -= 9;
      }
      sum += digit;
      shouldDouble = !shouldDouble;
    }
    return sum % 10 === 0;
  };
  // Validate the phone number using a regex
  const isValidPhone = (value) => {
    let isValidPhoneNumber = true;
    const regex = /^\(\d{3}\) \d{3}-\d{4}$/;
    if (!regex.test(value) && value.length === 14) {
      // 14 is length of (XXX) XXX-XXXX format
      isValidPhoneNumber = false;
    }
    return isValidPhoneNumber;
  };
  //Validate CC phone number
  /* const isValidPhone = (value, options = {}) => {
    let isValidphone = true;

    // Regular expressions for various formats
    /*  const myRegexPlain = new RegExp("^[0-9]{10}$");
    const myRegexHyphen = new RegExp("^[0-9]{3}-[0-9]{3}-[0-9]{4}$");
    const myRegexParent = new RegExp("^\\([0-9]{3}\\)-[0-9]{3}-[0-9]{4}$");

    // Remove white spaces
    const cleanValue = value.replace(/ /g, "");

    // Default options for validation behavior
    const defaults = {
      classEdit: false,
      className: "field_required",
      multiField: false,
      phoneGroupClass: "ssn_group_fields",
    };

    // Merge user options with defaults
    options = { ...defaults, ...options };

    // Skip validation if the field is blank
    if (cleanValue.trim() === "") {
      return true;
    }

    // Check different phone formats
    if (cleanValue.indexOf("-") >= 0) {
      if (myRegexHyphen.test(cleanValue)) {
        isValid = true;
      }
    } else if (cleanValue.indexOf("(") >= 0) {
      if (myRegexParent.test(cleanValue)) {
        isValid = true;
      }
    } else if (options.multiField === true) {
      let myPhone = "";

      // If multiField is true, concatenate values from multi-field inputs
      const phoneInputs = document.querySelectorAll(
        `.${options.phoneGroupClass}`
      );
      phoneInputs.forEach((input) => {
        myPhone += input.value;
      });

      // Check if the concatenated phone number is valid
      if (myRegexPlain.test(myPhone)) {
        isValid = true;
      }
    } else if (myRegexPlain.test(cleanValue)) {
      isValid = true;
    }*/
  /* const phoneRegex = /^(?:\(\d{3}\)\s?|\d{3}[-.\s]?)\d{3}[-.\s]?\d{4}$/;
    if (!phoneRegex.test(value)) {
      isValidphone = false;
    }
    return isValidphone;
  };*/
  const validateAddress = (value) => {
    const pattern = /^[0-9a-zA-Z ,&.'\-\/#;\)=:]{1,255}$/;
    return pattern.test(value); // allows letters, numbers, and spaces
  };
  const validateCity = (value) => {
    const pattern = /^[a-zA-Z ,&.'\-\/=]{1,255}$/;
    return pattern.test(value); // allows letters, numbers, and spaces
  };

  const accountFormValidate = () => {
    const newErrors = {};
    let isValid = true;
    if (!form.routingNumber && form.routingNumber === "") {
      newErrors.routingNumber = cms.invald_pmt_routing_no;
      isValid = false;
    }

    if (!/^\d{9}$/.test(form.routingNumber)) {
      newErrors.routingNumber = cms.invalid_account_num_match;
      isValid = false;
    }

    if (!form.reRoutingNumber && form.routingNumber === "") {
      newErrors.reRoutingNumber = cms.label_pmt_routing_no_renter;
      isValid = false;
    }
    if (form.routingNumber !== form.reRoutingNumber) {
      newErrors.reRoutingNumber = cms.invalid_routing_num_match;
      isValid = false;
    }

    if (!form.accountNumber && form.accountNumber === "") {
      newErrors.accountNumber = cms.invalid_pmt_accnt_no;
      isValid = false;
    }
    if (!/^\d+$/.test(form.accountNumber)) {
      newErrors.accountNumber = cms.invalid_account_num_validation;
      isValid = false;
    }
    if (form?.accountNumber.length < 4 || form?.accountNumber.length > 17) {
      newErrors.accountNumber = cms.invalid_account_num_min_max_validation;
      isValid = false;
    }
    if (!form.reAccountNumber && form.reAccountNumber === "") {
      newErrors.reAccountNumber = cms.invalid_pmt_reenter_acc_no;
      isValid = false;
    }
    if (form.accountNumber !== form.reAccountNumber) {
      newErrors.reAccountNumber = cms.invalid_pmt_account_match;
      isValid = false;
    }

    if (!form.accountType && form.accountType === "") {
      newErrors.accountType = cms.invalid_pmt_account_type;
      isValid = false;
    }
    if (!form.bankAccountHolderName) {
      newErrors.bankAccountHolderName = cms.invalid_pmt_accnt_holder_name;
      isValid = false;
    }
    if (form?.bankAccountHolderName) {
      const regex = /^[A-Za-z\s]+$/;
      if (!regex.test(form.bankAccountHolderName)) {
        newErrors.bankAccountHolderName = cms?.invalid_char_bank_account_name;
        isValid = false;
      }
    }
    if (!form.billingAddress1) {
      newErrors.billingAddress1 = cms.invalid_pmt_billing_addr1;
      isValid = false;
    }
    if (form.billingAddress1) {
      if (!validateAddress(form.billingAddress1)) {
        newErrors.billingAddress1 = cms.invalid_special_char_pmt_billing_addr1;
        isValid = false;
      }
    }
    if (form.billingAddress2) {
      if (!validateAddress(form.billingAddress2)) {
        newErrors.billingAddress2 = cms.invalid_special_char_pmt_billing_addr2;
        isValid = false;
      }
    }
    if (form.email) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(form.email)) {
        newErrors.email = cms.invalid_email;
        isValid = false;
      }
    }
    if (!form.city) {
      newErrors.city = cms.invalid_pmt_city;
      isValid = false;
    }
    if (form.city) {
      if (!validateCity(form.city)) {
        newErrors.city = cms.invalid_special_char_pmt_city;
        isValid = false;
      }
    }
    if (!form.state) {
      newErrors.state = cms.invalid_pmt_state;
      isValid = false;
    }
    if (!form.zip) {
      newErrors.zip = cms.invalid_pmt_zip;
      isValid = false;
    }else{
      if (!/^\d{5}(-\d{4})?$/.test(form.zip)) {
        newErrors.zip = cms.invalid_zip_code_format;
        isValid = false;
      }
    }

    if (!form.phoneNumber) {
      newErrors.phoneNumber = cms.invalid_pmt_phno;
      isValid = false;
    } else {
      if (!isValidPhone(form.phoneNumber)) {
        newErrors.phoneNumber = cms.invalid_phone_num;
        isValid = false;
      }
    }

    if ((Number(payOtherAmount) === 0 && !showTotalAmt) || payOtherAmtErr) {
      updatePayOtherAmtErr(cms.required_payment_amount);
      isValid = false;
    }

    if (showTotalAmt && !showOtherAmt && Number(totalAmountDue) === 0) {
      updateTotalAmtDueErr(cms.required_payment_amount);
      isValid = false;
    }
    if (showTotalAmt && !showOtherAmt && Number(totalAmountDue) !== 0) {
      const totalAmtErr = handlePayTotalAmtdue(totalAmountDue);
      if (totalAmtErr === "error") {
        isValid = false;
      }
    }

    setAccountErrors(newErrors);
    if (!isValid) {
      setErrorText(cms.required_all_fields);
    }
    return isValid;
  };
  const accountValidate = () => {
    const newErrors = {};
    let isValid = true;

    /* if (!/^\d{10}$/.test(form.phoneNumber)) {
      newErrors.phoneNumber = "Phone Number must be 10 digits";
      isValid = false;
    }*/
    const isValidForm = accountFormValidate();

    if (isValidForm) {
      if (!form.termsConditions) {
        newErrors.termsConditions = cms.required_terms_conds;
        isValid = false;
      }
      if (!form.eSign) {
        newErrors.eSign = cms.required_esign;
        isValid = false;
      }
    } else {
      return isValidForm;
    }

    // Sanitize card data after validation, before submission
    const sanitizedAccount = sanitizeFormData(form);
    setForm(sanitizedAccount);

    setAccountErrors(newErrors);

    return isValid; // Return true if no errors
  };

  const cardFormValidate = () => {
    let newErrors = {};
    let isValidFields = true;

    if (card?.cardNumber === "") {
      newErrors.cardNumber = cms.invalid_pmt_card_number;
      isValidFields = false;
    } else {
      if (card?.cardNumber && !validateCreditCard(card.cardNumber)) {
        newErrors.cardNumber = cms.invalid_card_number;
        isValidFields = false;
      }
    }

    if (!card?.reEnterCardNumber && card?.reEnterCardNumber === "") {
      newErrors.reEnterCardNumber = cms.invalid_pmt_reentercard_number;
      isValidFields = false;
    }
    if (
      card?.cardNumber &&
      card?.reEnterCardNumber &&
      card.cardNumber !== card.reEnterCardNumber
    ) {
      newErrors.reEnterCardNumber = cms.invalid_ccd_num;
      isValidFields = false;
    }
    if (!newErrors.cardNumber) {
      if (cardErrors?.cardTypeSelect || !card?.cardTypeSelect) {
        if (cardErrors?.cardTypeSelect) {
          newErrors.cardTypeSelect = cardErrors.cardTypeSelect;
        } else {
          newErrors.cardTypeSelect = cms.invalid_pmt_card_type;
        }
        isValidFields = false;
      }
    }

    if (!card?.cardAccountName) {
      newErrors.cardAccountName = cms.invalid_pmt_account_name;
      isValidFields = false;
    }
    if (card?.cardAccountName) {
      const regex = /^[A-Za-z\s]+$/;
      if (!regex.test(card.cardAccountName)) {
        newErrors.cardAccountName = cms?.invalid_char_pmt_account_name;
        isValidFields = false;
      }
    }
    // if (!card.email) newErrors.email = 'Email is required';
    // if (!/\S+@\S+\.\S+/.test(card.email)) newErrors.email = 'Email is invalid';
    if (!card?.cardBillingAddress1) {
      newErrors.cardBillingAddress1 = cms.invalid_pmt_billing_addr1;
      isValidFields = false;
    }
    if (card.cardBillingAddress1) {
      if (!validateAddress(card.cardBillingAddress1)) {
        newErrors.cardBillingAddress1 =
          cms.invalid_special_char_pmt_billing_addr1;
        isValidFields = false;
      }
    }
    if (card.cardBillingAddress2) {
      if (!validateAddress(card.cardBillingAddress2)) {
        newErrors.cardBillingAddress2 =
          cms.invalid_special_char_pmt_billing_addr2;
        isValidFields = false;
      }
    }
    if (card?.email) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(card.email)) {
        newErrors.email = cms.invalid_email;
        isValidFields = false;
      }
    }
    if (!card?.city) {
      newErrors.city = cms.invalid_pmt_city;
      isValidFields = false;
    }
    if (card.city) {
      if (!validateCity(card.city)) {
        newErrors.city = cms.invalid_special_char_pmt_city;
        isValidFields = false;
      }
    }
    if (!card?.state) {
      newErrors.state = cms.invalid_pmt_state;
      isValidFields = false;
    }

    if (!card?.zip) {
      newErrors.zip = cms.invalid_pmt_zip;
      isValidFields = false;
    } else {
      if (!/^\d{5}(-\d{4})?$/.test(card.zip)) {
        newErrors.zip = cms.invalid_zip_code;
        isValidFields = false;
      }
    }

    if (!card?.phoneNumber) {
      newErrors.phoneNumber = cms.invalid_pmt_phno;
      isValidFields = false;
    } else {
      /* if (!/^\d{10}$/.test(card.phoneNumber)) {
        newErrors.phoneNumber = "Phone number must be 10 digits";
        isValid = false;
      }*/
      if (!isValidPhone(card.phoneNumber)) {
        newErrors.phoneNumber = cms.invalid_phone_num;
        isValidFields = false;
      }
    }

    if (!card?.expiry) {
      newErrors.expiry = cms.invalid_pmt_expiry_date;
      isValidFields = false;
    }

    if (card?.expiry) {
      const expiryRegex = /^(0[1-9]|1[0-2])\/\d{2}$/; // Allows 01/23 to 12/99
      if (!expiryRegex.test(card.expiry)) {
        newErrors.expiry = cms.invalid_exp_date;
        isValidFields = false;
      } else {
        // Extract month and year
        const [month, year] = card.expiry
          .split("/")
          .map((val) => parseInt(val, 10));

        // Create a Date object for the expiry date
        const expiryDate = new Date(`20${year}-${month}-01`);

        // Check if the expiry date is in the future
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0); // Set current date to midnight for comparison

        if (expiryDate < currentDate) {
          newErrors.expiry = cms.invalid_pmt_expiry_date_message; // You can customize this message in your CMS
          isValidFields = false;
        }
      }
    }
    /* const expiryRegex = /^(0[1-9]|1[0-2])\/\d{2}$/; // Allows 01/23 to 12/99
      if (!expiryRegex.test(card.expiry)) {
        newErrors.expiry = cms.invalid_exp_date;
        isValidFields = false;
      } else {
        // Extract month and year
       const [month, year] = card.expiry
          .split("/")
          .map((val) => parseInt(val, 10));

        // Create a Date object for the expiry date
        const expiryDate = new Date(`20${year}-${month}-01`);

        // Check if the expiry date is in the future
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0); // Set current date to midnight for comparison

        if (expiryDate < currentDate) {
          newErrors.expiry = "Expiry date is not valid"; // You can customize this message in your CMS
          isValidFields = false;
        }
      }*/
    /*if (!/\d{2}\/\d{2}/.test(card.expiry)) {
        newErrors.expiry = cms.invalid_exp_date;
        isValidFields = false;
      }
    }*/

    if (!card?.cvv) {
      newErrors.cvv = cms.invalid_pmt_cvv;
      isValidFields = false;
    } else {
      if (!/^\d{3,4}$/.test(card.cvv)) {
        newErrors.cvv = cms.invalid_cvv;
        isValidFields = false;
      }
    }
    if ((Number(payOtherAmount) === 0 && !showTotalAmt) || payOtherAmtErr) {
      updatePayOtherAmtErr(cms.required_payment_amount);
      isValidFields = false;
    }

    if (showTotalAmt && !showOtherAmt && Number(totalAmountDue) === 0) {
      updateTotalAmtDueErr(cms.required_payment_amount);
      isValidFields = false;
    }
    if (showTotalAmt && !showOtherAmt && Number(totalAmountDue) !== 0) {
      const totalAmtErr = handlePayTotalAmtdue(totalAmountDue);

      if (totalAmtErr === "error") {
        isValidFields = false;
      }
    }

    setCardErrors(newErrors);
    if (!isValidFields) {
      setErrorText(cms.required_all_fields);
    }

    return isValidFields;
  };
  const cardValidate = () => {
    const isValidForm = cardFormValidate();
    let newErrors = {};
    let isValid = true;

    /* if (!card.accountType) {
      newErrors.accountType = "Account Type is required";
      isValid = false;
    }*/
    if (isValidForm) {
      if (!card.termsConditions) {
        newErrors.termsConditions = cms.required_terms_conds;
        isValid = false;
      }
      if (!card.eSign) {
        newErrors.eSign = cms.required_esign;
        isValid = false;
      }
    } else {
      return isValidForm;
    }
    //To prevent XSS attack and HTML injection
    // Sanitize card data after validation, before submission
    const sanitizedCard = sanitizeFormData(card);
    setCard(sanitizedCard);
    // if (card.cardNumber<=16) {
    //     newErrors.cardNumber = 'Card Number must be greater than 16 Digits';
    //     isValid = false
    // }

    /* console.log(newErrors, "newErrors");*/
    setCardErrors(newErrors);
    return isValid;
  };
  const getMonthEndDate = (month, year) => {
    // Month is 0-based, so January is 0, February is 1, and so on.
    // Create a new Date object for the first day of the next month.
    const fullYear = year < 100 ? 2000 + year : year; // If year is < 100, prepend '20'
    const date = new Date(fullYear, month + 1, 0);
    const yearFormatted = date.getUTCFullYear();
    const monthFormatted = (date.getUTCMonth() + 1).toString().padStart(2, "0"); // Adds leading zero
    const dayFormatted = date.getUTCDate().toString().padStart(2, "0"); // Adds leading zero

    return `${yearFormatted}-${monthFormatted}-${dayFormatted}`;
  };
  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, "0"); // Adds leading zero
    const day = today.getDate().toString().padStart(2, "0"); // Adds leading zero

    return `${year}-${month}-${day}`;
  };
  const formatDate = (date) => {
    const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Month is 0-indexed, so add 1
    const day = String(date.getUTCDate()).padStart(2, "0");
    const year = date.getUTCFullYear();
    return `${month}/${day}/${year}`;
  };

  //Combine payload and headers for log API
  // Convert FormData to a plain JavaScript object
  function formDataToObject(formData) {
    const obj = {};
    formData.forEach((value, key) => {
      obj[key] = value;
    });
    return obj;
  }

  // Combine payload and headers
  const combinePayloadAndHeaders = useCallback((payload, headers) => {
    const payloadObject = formDataToObject(payload);

    // Combine payload and headers
    const combined = {
      payload: payloadObject,
      headers: headers,
    };

    return JSON.stringify(combined, null, 2); // Pretty print the JSON (optional)
  }, []);

  //Insert Payment Token and Scheule Payment
  const insertPymtTokenAndSchedulePymt = (tokenizationResp, params) => {
    const accountLast4 = params?.cc_number
      ? params.cc_number.toString().slice(-4)
      : params?.check_number
      ? params.check_number.toString().slice(-4)
      : "";
    const accountType = showCardTab ? "CREDIT_CARD" : showEftTab ? "EFT" : "";

    const accountUse = params?.check_level ? params.check_level : "PERSONAL";
    const sourceType = showCardTab ? "CCD" : showEftTab ? "EFT" : "";
    const bankAcctType = params?.check_type ? params.check_type : "";
    //const cardCvvNo = params?.card_cvNumber ? params.card_cvNumber : "";
    const ccExpiryDate =
      params?.cc_exp_month && params?.cc_exp_year
        ? getMonthEndDate(
            parseInt(params.cc_exp_month, 10) - 1,
            parseInt(params.cc_exp_year, 10)
          )
        : "";
    let amount =
      payOtherAmount && !showTotalAmt ? payOtherAmount : totalAmountDue;
    const routingNumber = params?.check_routing ? params.check_routing : "";
    const cardProcessor = params?.cc_type ? params.cc_type : "";
    const respCardType = tokenizationResp.card_type
      ? tokenizationResp.card_type
      : "";

    const payload = new FormData();

    // Append your form fields to FormData
    payload.append("cim", cim);
    payload.append("accountHolderName", params.first_name);
    payload.append("accountHolderPhone", params.phone);
    payload.append("accountLast4", accountLast4);
    payload.append("accountTokenId", "0");
    payload.append("accountType", accountType);
    payload.append("accountUse", accountUse);
    payload.append("address1", params.street1);
    payload.append("address2", params.street2);
    payload.append("city", params.city);
    payload.append("state", params.state);
    payload.append("zip", params.zip);
    payload.append("zipPlus4", "");
    payload.append("sourceType", sourceType);
    payload.append("bankAcctType", bankAcctType);
    if (showEftTab) {
      payload.append("eftTransitNumber", routingNumber);
      payload.append("eftAccountType", bankAcctType);
    }
    if (showCardTab) {
      payload.append("cardProcessor", cardProcessor);
      payload.append("ccdExpirationDate", ccExpiryDate);
    }
    let todayDate = getTodayDate();
    payload.append("nonRecurringToken", "Y");
    payload.append(
      "avsConfirmationNum",
      tokenizationResp.avs_confirmation_number
    );
    payload.append("avsResponse", tokenizationResp.avs_response);
    payload.append("avsTokenizationTimestamp", tokenizationResp.avs_timestamp);
    payload.append("avstokenId", tokenizationResp.token);
    payload.append("paymentMethod", accountType);
    payload.append("scheduledDate", todayDate);
    payload.append("amount", amount);
    payload.append("isDebitPaymtAllowed", isCardTypeAllowed); //PMO0001747 Phase 2
    if (showCardTab) {
      payload.append("cardType", respCardType);
    }

    payload.append(
      "authMessage",
      sessionStorage.getItem("nacha_" + urlCarrier)
      //nachaAuthMessage
    );
    //For ETLOG
    payload.append("caseNum", caseNum);
    payload.append("HIXIndicator", hixIndicator);
    payload.append("contactName", contactName);

    const carr_code = "REACT_APP_" + urlCarrier.toUpperCase();
    const carr_code_val = process.env[carr_code];
    const schedule_pymt_client_id =
      "REACT_APP_SCHEDULE_PYMT_API_CLIENT_ID_" + carr_code_val;
    const schedule_pymt_client_secret =
      "REACT_APP_SCHEDULE_PYMT_API_CLIENT_SECRET_" + carr_code_val;
    const guid = uuidv4();
    const headers = {
      "X-Hps-Trace-Id": guid,
      "X-Hps-Ts": Date.now(),
      "X-Hps-Carrier-Code": process.env[carr_code],
      "X-Hps-Sender-Id": "GUEST PAYMENT PORTAL",
      "X-Hps-SiteCd": process.env[carr_code] + "GPT",
      "X-Hps-Client-Id": process.env[schedule_pymt_client_id],
      "X-Hps-Secret-Id": process.env[schedule_pymt_client_secret],
      "X-Hps-Db-Region": process.env.REACT_APP_REGION,
    };

    if (payload) {
      const request_to_log = combinePayloadAndHeaders(payload, headers);
      postData(
        process.env.REACT_APP_SCHEDULE_PYMT_API_URL,
        "",
        payload,
        headers
      )
        .then((result) => {
          if (result) {
            if (result.status && result.data && result.status === 200) {
              const response = result.data;

              if (!response.error) {
                if (response.status_code === "HPS200") {
                  if (response.payment_confirmation) {
                    Log(
                      "Schedule Payment API",
                      "API",
                      caseNum,
                      "API success.Payment has been Scheduled.",
                      "INFO",
                      request_to_log,
                      result,
                      process.env.REACT_APP_SCHEDULE_PYMT_API_URL,
                      "S"
                    );
                    setNotifySuccess("Payment has been Scheduled!");
                    const payment_method = showCardTab ? "CARD" : showEftTab ? "EFT" : "";
                    const cim = response.payment_confirmation?.cim;
                    const confirmation_no =
                      response.payment_confirmation?.confirmationNumber;

                    const pymtConfirmData = encryptData(
                      "cim=" +
                        cim +
                        "&confirmation_no=" +
                        confirmation_no +
                        "&name=" +
                        params.first_name +
                        "&scheduled_date=" +
                        todayDate +
                        "&amount=" +
                        amount +
                        "&payment_type=" +
                        sourceType +
                        "&lastfour=" +
                        accountLast4 +
                        "&payment_method=" +
                        payment_method +
                        "&onetime_binder=" +
                        paymentType
                    );
                    navigate("/" + urlCarrier + "/confirm?" + pymtConfirmData);
                  } else {
                    Log(
                      "Schedule Payment API",
                      "API",
                      caseNum,
                      "API failure.Payment has not been Scheduled.",
                      "ERROR",
                      request_to_log,
                      result,
                      process.env.REACT_APP_SCHEDULE_PYMT_API_URL,
                      "F"
                    );
                    setErrorText(cms.payment_scheduled_err);
                  }
                } else {
                  Log(
                    "Schedule Payment API",
                    "API",
                    caseNum,
                    "API failure.Payment has not been Scheduled.",
                    "ERROR",
                    request_to_log,
                    result,
                    process.env.REACT_APP_SCHEDULE_PYMT_API_URL,
                    "F"
                  );
                  setErrorText(cms.payment_scheduled_err);
                }
              } else {
                Log(
                  "Schedule Payment API",
                  "API",
                  caseNum,
                  "API failure.Payment has not been Scheduled.",
                  "ERROR",
                  request_to_log,
                  result,
                  process.env.REACT_APP_SCHEDULE_PYMT_API_URL,
                  "F"
                );
                setErrorText(cms.payment_scheduled_err);
              }
            } else {
              Log(
                "Schedule Payment API",
                "API",
                caseNum,
                "API failure.Payment has not been Scheduled.",
                "ERROR",
                request_to_log,
                result,
                process.env.REACT_APP_SCHEDULE_PYMT_API_URL,
                "F"
              );
              setErrorText(
                cms.failed_payment_technical_error + cms.payment_scheduled_err
              );
            }
          } else {
            setErrorText(
              cms.failed_payment_technical_error + cms.payment_scheduled_err
            );
          }
        })
        .catch((error) => {
          if (error.response) {
            // The request was made and the server responded with a status code
            if (error.response.status === 404) {
              setErrorText(
                cms.failed_payment_technical_error + cms.payment_scheduled_err
              );
            } else {
              setErrorText(
                "PAYMENT ERR: " +
                  cms.failed_payment_technical_error +
                  error.response.status +
                  " : " +
                  error.response.statusText
              );
            }
          } else if (error.request) {
            // The request was made but no response was received
            setErrorText(
              "PAYMENT ERR: " +
                cms.failed_payment_technical_error +
                error.request.status +
                " : " +
                error.response.statusText
            );
          } else {
            // Something happened in setting up the request that triggered an Error
            const errMsg = error.message ? error.message : "";
            setErrorText(
              "PAYMENT ERR: " + cms.failed_payment_technical_error + errMsg
            );
          }
          Log(
            "Schedule Payment API",
            "API",
            caseNum,
            "Got exception: API failure. Payment has not been Scheduled.",
            "ERROR",
            request_to_log,
            error,
            process.env.REACT_APP_SCHEDULE_PYMT_API_URL,
            "F"
          );
        })
        .finally(() => {
          // Code that runs regardless of success or failure
          setLoading(false);
        });
    } else {
      Log(
        "Schedule Payment API",
        "API",
        caseNum,
        "API failure. Payload not set. Payment has not been Scheduled.",
        "ERROR",
        headers,
        "Payload not set",
        process.env.REACT_APP_SCHEDULE_PYMT_API_URL,
        "F"
      );
    }
  };
  //Get gateway id for creating account - for Sentara
  const getGatewayIdByCim = () => {
    const carr_code = "REACT_APP_" + urlCarrier.toUpperCase();
    let response = "";
    const guid = uuidv4();

    const headers = {
      "X-Hps-Trace-Id": guid,
      "X-Hps-Ts": Date.now(),
      "X-Hps-Carrier-Code": process.env[carr_code],
      "X-Hps-Sender-Id": "GUEST PAYMENT PORTAL",
      "X-Hps-SiteCd": process.env[carr_code] + "GPT",
      "X-Hps-Client-Id": process.env.REACT_APP_MERCHANT_GATEWAY_API_CLIENT_ID,
      "X-Hps-Secret-Id":
        process.env.REACT_APP_MERCHANT_GATEWAY_API_CLIENT_SECRET,
      "X-Hps-Db-Region": process.env.REACT_APP_REGION,
    };

    getAPIData(
      process.env.REACT_APP_MERCHANT_GATEWAY_API_URL + "/" + cim,
      "",
      headers
    )
      .then((result) => {
        if (result) {
          if (result.status && result.data && result.status === 200) {
            response = result.data;
            if (!response.error) {
              if (response.status_code === "HPS200") {
                Log(
                  "Merchant gateway API",
                  "API",
                  caseNum,
                  "API success",
                  "INFO",
                  headers,
                  result,
                  process.env.REACT_APP_MERCHANT_GATEWAY_API_URL + "/" + cim,
                  "S"
                );
                return response;
              } else {
                Log(
                  "Merchant gateway API",
                  "API",
                  caseNum,
                  "API failure",
                  "ERROR",
                  headers,
                  result,
                  process.env.REACT_APP_MERCHANT_GATEWAY_API_URL + "/" + cim,
                  "F"
                );
              }
            } else {
              Log(
                "Merchant gateway API",
                "API",
                caseNum,
                "API failure",
                "ERROR",
                headers,
                result,
                process.env.REACT_APP_MERCHANT_GATEWAY_API_URL + "/" + cim,
                "F"
              );
            }
          } else {
            const errorTxt = "Merchant gateway: " + result.status;
            var resultErr = "";
            if (result.error) {
              resultErr = result.error;
            }
            if (result.errors && result.errors.text) {
              resultErr += result.errors.text;
            }
            Log(
              "Merchant gateway API",
              "API",
              caseNum,
              "API failure",
              "ERROR",
              headers,
              result,
              process.env.REACT_APP_MERCHANT_GATEWAY_API_URL + "/" + cim,
              "F"
            );
          }
        } else {
          Log(
            "Merchant gateway API",
            "API",
            caseNum,
            "API failure",
            "ERROR",
            headers,
            result,
            process.env.REACT_APP_MERCHANT_GATEWAY_API_URL + "/" + cim,
            "F"
          );
        }
      })
      .catch((error) => {
        let errMsg = "";
        if (error.response) {
          // The request was made and the server responded with a status code

          errMsg =
            "Merchant Gateway ERR: " +
            cms.failed_payment_technical_error +
            " : " +
            error.response.status +
            " : " +
            error.response.statusText;
        } else if (error.request) {
          // The request was made but no response was received
          errMsg =
            "Merchant Gateway ERR: " +
            cms.failed_payment_technical_error +
            error.request.status +
            " : " +
            error.response.statusText;
        } else {
          // Something happened in setting up the request that triggered an Error
          errMsg = error.message ? error.message : "";
          errMsg =
            "Merchant Gateway ERR: " +
            cms.failed_payment_technical_error +
            errMsg;
        }
        Log(
          "Merchant gateway API",
          "API",
          caseNum,
          "Got exception: API failure",
          "ERROR",
          headers,
          errMsg,
          process.env.REACT_APP_MERCHANT_GATEWAY_API_URL + "/" + cim,
          "F"
        );
      })
      .finally(() => {
        // Code that runs regardless of success or failure
        const gatewayId = response?.gateway_id ? response.gateway_id : "";
        makeReqAndCreateAccount(gatewayId);
      });
  };
  //Make resquest for create account
  const makeReqAndCreateAccount = (gatewayId) => {
    const headers = {
      "Content-Type": "application/x-www-form-urlencoded",
    };
    const carr_code = "REACT_APP_" + urlCarrier.toUpperCase();
    let body_post_encrypt = "";
    let body_pre_encrypt = "";

    if (showCardTab) {
      const [exp_month, exp_year] = (card.expiry || "").split("/");

      let cc_type = card?.cardTypeSelect.toUpperCase();

      if (["VISA"].includes(cc_type)) {
        cc_type = "VISA";
      } else if (["MASTERCARD", "MC", "MAST"].includes(cc_type)) {
        cc_type = "MC";
      } else if (["DISCOVER", "DISC"].includes(cc_type)) {
        cc_type = "DISC";
      } else if (
        ["AMERICAN-EXPRESS", "AMERICAN EXPRESS", "AMEX"].includes(cc_type)
      ) {
        cc_type = "AMEX";
      }
      body_pre_encrypt = {
        w1: "PciTokenCTL/PciWebProcessCTL",
        no_html: "true",
        process_type: "TOKENIZE_WEB_DATA",
        method: "CC",
        first_name: card?.cardAccountName,
        last_name: card?.cardAccountName,
        street1: card?.cardBillingAddress1,
        street2: card?.cardBillingAddress2,
        city: card?.city,
        state: card?.state,
        zip: card?.zip,
        country: "US",
        email: card?.email ? card.email : "default@default.com",
        phone: card?.phoneNumber ? card.phoneNumber : "9999999999",
        carrier_code: process.env[carr_code],
        response_type: "json",
        cc_type: cc_type,
        cc_number: card?.cardNumber,
        card_cvNumber: card?.cvv,
        cc_exp_month: exp_month,
        cc_exp_year: exp_year,
        currency: "usd",
        debit_card_flag: enableDebitCheck ? "true" : "false",
        binder_flag: paymentType && paymentType === "BINDER" ? "true" : "false",
        gateway_id: gatewayId,
      };

      body_post_encrypt = getEncryptedPostdataString(body_pre_encrypt);
    }
    if (showEftTab) {
      let eftLevelAndType = form?.accountType.split("-");

      let eft_type = eftLevelAndType[1].toUpperCase();
      if (["CHECKING", "C"].includes(eft_type)) {
        eft_type = "CHECKING";
      } else if (["SAVINGS", "SAVING", "S"].includes(eft_type)) {
        eft_type = "SAVING";
      }

      body_pre_encrypt = {
        w1: "PciTokenCTL/PciWebProcessCTL",
        no_html: "true",
        process_type: "TOKENIZE_WEB_DATA",
        method: "EFT",
        check_routing: form?.routingNumber,
        check_number: form?.accountNumber,
        check_level:
          eftLevelAndType[0] === "B" || eftLevelAndType[0] === "BUSINESS"
            ? "BUSINESS"
            : "PERSONAL",
        check_type: eft_type,
        first_name: form?.bankAccountHolderName,

        last_name: form?.bankAccountHolderName,
        // bankAccountHolderName: form?.bankAccountHolderName,
        street1: form?.billingAddress1,
        street2: form?.billingAddress2,
        carrier_code: process.env[carr_code],
        response_type: "json",
        email: form?.email,
        city: form?.city,
        state: form?.state,
        zip: form?.zip,
        phone: form?.phoneNumber,
        currency: "usd",
        gateway_id: gatewayId,
      };
      body_post_encrypt = getEncryptedPostdataString(body_pre_encrypt);
    }
    createAccount(body_post_encrypt, headers, body_pre_encrypt);
  };
  //Account creation-Tokenization
  const createAccount = (body, headers, body_pre_encrypt) => {
    let response = "";
    // Add query parameters to the URL if available
    let fullUrl = process.env.REACT_APP_PCI_API_HTTP_URL;

    if (fullUrl.indexOf("?") > -1) {
      fullUrl +=
        "&no_html=true&process_type=TOKENIZE_WEB_DATA&response_type=json";
    } else {
      fullUrl +=
        "?no_html=true&process_type=TOKENIZE_WEB_DATA&response_type=json";
    }

    if (body) {
      fullUrl += `&${body}`;
    }

    // Prevent caching by adding a timestamp
    fullUrl += `&_=${new Date().getTime()}`;
    getAPIData(fullUrl, "", headers)
      .then((result) => {
        if (result) {
          if (result.status && result.data && result.status === 200) {
            response = result.data;
            if (!response.error) {
              Log(
                "Create account PCI tokenization API",
                "API",
                caseNum,
                "API success",
                "INFO",
                "",
                result,
                "",
                "S"
              );
            } else {
              Log(
                "Create account PCI tokenization API",
                "API",
                caseNum,
                "Got response.error : API failure",
                "ERROR",
                "",
                result,
                "",
                "F"
              );
              setErrorText(cms.failed_payment_general_err);
            }
          } else if (result.status === 404) {
            Log(
              "Create account PCI tokenization API",
              "API",
              caseNum,
              "Got result status as 404: API failure",
              "ERROR",
              "",
              result,
              "",
              "F"
            );
            setErrorText(result.status + " " + cms.failed_payment_general_err);
          } else {
            const errorTxt = cms.label_pmt_make_payment + result.status;
            var resultErr = "";
            if (result.error) {
              resultErr = result.error;
            }
            if (result.errors && result.errors.text) {
              resultErr += result.errors.text;
            }
            setErrorText(errorTxt + "Technical Error : " + resultErr);
            Log(
              "Create account PCI tokenization API",
              "API",
              caseNum,
              "API failure",
              "ERROR",
              "",
              result,
              "",
              "F"
            );
          }
        } else {
          Log(
            "Create account PCI tokenization API",
            "API",
            caseNum,
            "API failure",
            "ERROR",
            "",
            result,
            "",
            "F"
          );
          setErrorText("Technical Error");
        }
      })
      .catch((error) => {
        if (error.response) {
          // The request was made and the server responded with a status code
          setErrorText("Technical Error");
        } else if (error.request) {
          // The request was made but no response was received
          setErrorText("Technical Error");
        } else {
          // Something happened in setting up the request that triggered an Error
          setErrorText("Technical Error");
        }
        Log(
          "Create account PCI tokenization API",
          "API",
          caseNum,
          "Got exception: API failure",
          "ERROR",
          "",
          error,
          "",
          "F"
        );
      })
      .finally(() => {
        // Code that runs regardless of success or failure
        if (
          response?.reason &&
          response.reason === "ACCEPT" &&
          response?.token
        ) {
          insertPymtTokenAndSchedulePymt(response, body_pre_encrypt);
        } else {
          Log(
            "Create account PCI tokenization API",
            "API",
            caseNum,
            "API failure",
            "ERROR",
            "",
            "Got reject response from PCI tokenization or no response",
            "",
            "F"
          );
          setLoading(false);
          setErrorText(cms.failed_create_account_err);
        }

        /* if (showCardTab) {
            setCard({
              cardNumber: "",
              reEnterCardNumber: "",
              cardTypeSelect: "",
              cardAccountName: "",
              accountType: "",
              cardBillingAddress1: "",
              cardBillingAddress2: "",
              email: "",
              city: "",
              state: "",
              zip: "",
              phoneNumber: "",
              expiry: "",
              cvv: "",
            });
          }
          if (showEftTab) {
            setForm({
              routingNumber: "",
              reRoutingNumber: "",
              accountNumber: "",
              reAccountNumber: "",
              accountType: "",
              bankAccountHolderName: "",
              billingAddress1: "",
              billingAddress2: "",
              email: "",
              city: "",
              state: "",
              zip: "",
              phoneNumber: "",
            });
          }*/
      });
  };

  /*  Modal for confirmation box*/
  const handleConfirmBoxSuccess = () => {
    setLoading(true);
    let gatewayId = "";

    let isEnableMultiGateway =
      "REACT_APP_MULTI_GATEWAY_" + urlCarrier.toUpperCase();
    //Sentara-get merchant gateway
    if (process.env[isEnableMultiGateway] === "TRUE") {
      //If multi gateway enabled, get gateway and call tokenization
      const gatewayResp = getGatewayIdByCim();
      gatewayId = gatewayResp?.gateway_id ? gatewayResp.gateway_id : "";
    } else {
      //Call only tokenization
      makeReqAndCreateAccount(gatewayId);
    }
    setShowConfirmBox(false);
  };

  const handleConfirmBoxCancel = () => {
    //setErrorText("Payment not scheduled!");
    setShowConfirmBox(false);
  };

  const handleShowConfirmBox = () => {
    setShowConfirmBox(true);
  };

  const onMakePaymentClick = (e) => {
    // const onMakePaymentClick=()=>setShow(true);

    e.preventDefault();

    /// let gatewayId = "";

    // let isEnableMultiGateway =
    //  "REACT_APP_MULTI_GATEWAY_" + urlCarrier.toUpperCase();
    if (showCardTab) {
      if (cardValidate()) {
        if (sessionStorage.getItem("nacha_" + urlCarrier)) {
          handleShowConfirmBox();
          /* setLoading(true);
          if (process.env[isEnableMultiGateway] === "TRUE") {
            //If multi gateway enabled, get gateway and call tokenization
            const gatewayResp = getGatewayIdByCim();
            gatewayId = gatewayResp?.gateway_id ? gatewayResp.gateway_id : "";
          } else {
            //Call only tokenization
            makeReqAndCreateAccount(gatewayId);
          }*/
        } else {
          setErrorText(cms.nacha_content_unavailable);
        }
      } else if (!cardValidate()) {
        // triggerToast(cms.required_all_fields, "error");
        setErrorText(cms.required_all_fields);
      }
    } else if (showEftTab) {
      if (accountValidate()) {
        if (sessionStorage.getItem("nacha_" + urlCarrier)) {
          handleShowConfirmBox();
          /*setLoading(true);
          if (process.env[isEnableMultiGateway] === "TRUE") {
            //If multi gateway enabled, get gateway and call tokenization
            const gatewayResp = getGatewayIdByCim();
            gatewayId = gatewayResp?.gateway_id ? gatewayResp.gateway_id : "";
          } else {
            //Call only tokenization
            makeReqAndCreateAccount(gatewayId);
          }*/
        } else {
          setErrorText(cms.nacha_content_unavailable);
        }
      } else if (!accountValidate()) {
        //triggerToast(cms.required_all_fields, "error");
        setErrorText(cms.required_all_fields);
      }
    }
  };

  //Nacha content
  useEffect(() => {
    let paymentMethodNacha = "";
    if (showCardTab) {
      paymentMethodNacha = "ccd";
    } else if (showEftTab) {
      paymentMethodNacha = "eft";
    }

    const binderMethodNacha = paymentType ? paymentType.toLowerCase() : "";

    if (paymentMethodNacha && binderMethodNacha && langSelected) {
      getNachaContent(paymentMethodNacha, binderMethodNacha);
    }
  }, [showCardTab, showEftTab, paymentType, getNachaContent, langSelected]);

  //confirmation box focus
  useEffect(() => {
    if (showConfirmBox) {
      const modal = document.getElementById("payment-confirm-box");
      if (modal) {
        modal.focus();
      }
    }
  }, [showConfirmBox]);
  //Update Nacha content

  /* useEffect(() => {
    replaceNachaPlaceholders();
  }, [
    showCardTab,
    showEftTab,
    card.cardNumber,
    form.accountNumber,
    currentDate,
    totalAmountDue,
    payOtherAmount,
    nachaCarrierName,
    nachaBillingFreq,
    showTotalAmt,
  ]);*/
  const formatAmount = (value) => {
    if (value !== null && value !== undefined) {
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    }
    return "0.00";
  };
  return (
    <>
      {/* Payment Method Tab*/}
      <div className="d-xl-flex d-md-flex align-items-start nav-pills nav-pills-custom d-sm-flex">
        <div
          className="nav flex-column nav-pills col-xl-3 col-sm-4 col-md-3"
          id="v-pills-tab"
          role="tablist"
          aria-orientation="vertical"
        >
          {(isEnableDebit || isEnableCredit) && (
            <button
              className={"nav-link mb-3 " + (showCardTab ? "active" : " ")} // add an additonal condtn for debit
              id="card-tab"
              data-bs-toggle="pill"
              data-bs-target="#card"
              type="button"
              role="tab"
              aria-controls="card"
              aria-selected={showCardTab ? "true " : "false"}
              onClick={showCard}
            >
              <span className="d-block mb-1">{cardButtonName}</span>
              {urlCarrier?.toLowerCase() === 'bcbsaz' ? (
                <img src={`${process.env.PUBLIC_URL}/images/icons/walletblue-bcbsaz.svg`} alt="Debit" style={{ width: '24px', height: '24px' }} />
              ) : (
                <i className="fe fe-wallet-r" />
              )}
            </button>
          )}

          {isEnableEft && (
            <button
              className={"nav-link mb-3 " + (showEftTab ? "active" : " ")} // add an additonal condtn for debit
              id="eft-tab"
              data-bs-toggle="pill"
              data-bs-target="#eft"
              type="button"
              role="tab"
              aria-controls="eft"
              aria-selected={showEftTab ? "true " : "false"}
              onClick={showEFT}
            >
              <span className="d-block mb-1">{cms.label_pmt_bank_account}</span>
              {urlCarrier?.toLowerCase() === 'bcbsaz' ? (
                <img src={`${process.env.PUBLIC_URL}/images/icons/bank-bcbsaz.svg`} alt="Bank" style={{ width: '24px', height: '24px' }} />
              ) : (
                <i className="fe fe-bank-r"></i>
              )}
            </button>
          )}
          {!isCarouselExcluded && (
            <img
              src={`${process.env.PUBLIC_URL}/images/illustrations/e-wallet-payment-${urlCarrier}.svg`}
              alt="Wallet-Girl"
              className="mw-90 mt-xl-5 mt-md-5 mb-3"
            />
          )}
        </div>
        {/* Payment Method Content Div*/}
        <div
          className="tab-content col-xl-9 col-sm-8 col-md-9"
          id="v-pills-tabContent"
        >
          <CardForm
            showCardTab={showCardTab}
            isEnableCredit={isEnableCredit}
            isEnableDebit={isEnableDebit}
            enableDebitCheck={enableDebitCheck}
            card={card}
            allowedCreditCardTypes={allowedCreditCardTypes}
            allowedDebitCardTypes={allowedDebitCardTypes}
            cardErrors={cardErrors}
            setCard={setCard}
            setCardErrors={setCardErrors}
            totalAmountDue={totalAmountDue}
            payOtherAmount={payOtherAmount}
            showTotalAmt={showTotalAmt}
            cms={cms}
            setShowSubmitBtn={setShowSubmitBtn}
            cardFormValidate={cardFormValidate}
            // setNachaAuthMessage={setNachaAuthMessage}
          ></CardForm>
          <EFTForm
            showEftTab={showEftTab}
            isEnableEft={isEnableEft}
            allowedEftTypes={allowedEftTypes}
            form={form}
            setForm={setForm}
            accountErrors={accountErrors}
            setAccountErrors={setAccountErrors}
            totalAmountDue={totalAmountDue}
            payOtherAmount={payOtherAmount}
            showTotalAmt={showTotalAmt}
            cms={cms}
            setShowSubmitBtn={setShowSubmitBtn}
            accountFormValidate={accountFormValidate}
            // setNachaAuthMessage={setNachaAuthMessage}
          ></EFTForm>
        </div>
      </div>

      <div className="col-xl-12 col-12 px-4 text-end me-2 mt-3 ms-3">
        {showConfirmBox && (
           <>
          {/* Overlay (backdrop) */}
        <div className="modal-backdrop fade show" style={{ zIndex: 1040 }}></div>
          <div
            className="modal fade show"
            style={{ display: "block" , zIndex: 1050 }}
            id="exampleModal"
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
          >
            <div className="modal-dialog text-center">
              <div className="modal-content"  tabIndex="0" id="payment-confirm-box">
                <div className="modal-header">
                  <h1
                    className="modal-title fs-5 confirm fw-semibold"
                    id="exampleModalLabel"
                  >
                    {cms?.label_confirm_popup_title}
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    onClick={handleConfirmBoxCancel}
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body payment">
                  <p
                      dangerouslySetInnerHTML={{
                        __html:
                          payOtherAmount &&
                            !showTotalAmt &&
                            parseFloat(payOtherAmount) > parseFloat(totalAmountDue)
                            ? cms?.label_confirm_popup_amount_exceeds.replace(
                              "%value%",
                              `<strong class="other-amount-value">
                                $${formatAmount(payOtherAmount)}
                              </strong>`
                            )
                            : payOtherAmount && !showTotalAmt
                            ? cms?.label_confirm_popup_amount_confirm.replace(
                              "%value%",
                              `<strong class="other-amount-value">$${formatAmount(payOtherAmount)}</strong>`
                            )
                            : cms?.label_confirm_popup_amount_confirm.replace(
                              "%value%",
                              `<strong class="other-amount-value">$${formatAmount(totalAmountDue)}</strong>`
                            ),
                        }}
                  ></p>
                  <p>
                    {" "}
                    {cms?.label_confirm_popup_pymt_scheduled}{" "}
                    <strong>{formatDate(new Date(getTodayDate()))}</strong>.
                  </p>
                </div>

                <div className="mb-3">
                  {/* Button order: For bcbsaz - Confirm first on mobile, Cancel first on desktop. For others - Confirm first always */}
                  {urlCarrier?.toLowerCase() === 'bcbsaz' ? (
                    <>
                      {/* Mobile: Confirm first, Cancel second */}
                      <button
                        type="button"
                        onClick={handleConfirmBoxSuccess}
                        className="btn btn-primary bg-blue btn-lg d-md-none"
                        id="liveAlertBtn-mobile"
                      >
                        {cms.label_confirm_popup_confirm}
                      </button>{" "}
                      <button
                        type="button"
                        onClick={handleConfirmBoxCancel}
                        className="btn btn-outline-secondary cancel-btn btn-lg d-md-none"
                        data-bs-dismiss="modal"
                      >
                        {cms?.label_confirm_popup_cancel}
                      </button>
                      {/* Desktop: Cancel first, Confirm second */}
                      <button
                        type="button"
                        onClick={handleConfirmBoxCancel}
                        className="btn btn-outline-secondary cancel-btn btn-lg d-none d-md-inline-block"
                        data-bs-dismiss="modal"
                      >
                        {cms?.label_confirm_popup_cancel}
                      </button>{" "}
                      <button
                        type="button"
                        onClick={handleConfirmBoxSuccess}
                        className="btn btn-primary bg-blue btn-lg d-none d-md-inline-block"
                        id="liveAlertBtn"
                      >
                        {cms.label_confirm_popup_confirm}
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        type="button"
                        onClick={handleConfirmBoxSuccess}
                        className="btn btn-primary bg-blue btn-lg"
                        id="liveAlertBtn"
                      >
                        {cms.label_confirm_popup_confirm}
                      </button>{" "}
                      <button
                        type="button"
                        onClick={handleConfirmBoxCancel}
                        className="btn btn-outline-secondary cancel-btn btn-lg"
                        data-bs-dismiss="modal"
                      >
                        {cms?.label_confirm_popup_cancel}
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="modal-dialogs text-center">
              <div id="liveAlertPlaceholder"></div>
            </div>
          </div>
          </>
        )}
        {loading && (
          <div className="d-flex justify-content-center mt-3">
            <Spinner animation="border" role="status" />
          </div>
        )}
        {showSubmitBtn && !loading && nachaContent && (
          <div>
            {isDisabledSubmitBtn && (
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="tooltip-top">
                    {cms.label_make_pymt_btn_tooltip}
                  </Tooltip>
                }
                delay={{ show: 250, hide: 400 }}
              >
                {/* Wrapper around the button to enable the tooltip for the disabled button */}
                <div style={{ display: "inline-block" }}>
                  <button
                    className="btn  btn-primary btn-lg button"
                    onClick={onMakePaymentClick}
                    disabled={isDisabledSubmitBtn}
                  >
                    {cms.label_pmt_make_payment}
                  </button>
                </div>
              </OverlayTrigger>
            )}
            {!isDisabledSubmitBtn && (
              <button
                className="btn  btn-primary btn-lg button"
                onClick={onMakePaymentClick}
                disabled={isDisabledSubmitBtn}
              >
                {cms.label_pmt_make_payment}
              </button>
            )}
          </div>
        )}
        {!nachaContent && (
          <p>
            {cms?.nacha_content_unavailable}. {cms?.label_reload}
          </p>
        )}
      </div>
    </>
  );
};

export default PaymentMethodTab;
